/**
 * External dependencies.
 */
import { has, isEmpty } from 'lodash';

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import { getSpacingCss } from '../../helpers/styles.js';
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props, selector = '' ) {
	const { blockAdvanceOptions, blockClientId } = props.attributes;
	selector = selector ? selector : `.gutenify-section-${ blockClientId }.wp-block-gutenify-post-carousel`;

	let css = '';

	// Item style.
	const innerBlockSelector = `${ selector } .gutenify-post-carousel-item-inner-wrapper`;

	let innerStyleVars = `${ has( blockAdvanceOptions, 'innerBlock.textColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.textColor ) ? `color: ${ blockAdvanceOptions.innerBlock.textColor };` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.borderColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderColor ) ? `border-color: ${ blockAdvanceOptions.innerBlock.borderColor };` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.borderWidth' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderWidth ) ? `border-width: ${ blockAdvanceOptions.innerBlock.borderWidth }px;` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.borderWidth' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderWidth ) ? `border-style: solid;` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.borderRadius' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderRadius ) ? `border-radius: ${ blockAdvanceOptions.innerBlock.borderRadius };` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.backgroundColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.backgroundColor ) ? `background: ${ blockAdvanceOptions.innerBlock.backgroundColor };` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.backgroundGradient' ) && ! isEmpty( blockAdvanceOptions.innerBlock.backgroundGradient ) ? `background: ${ blockAdvanceOptions.innerBlock.backgroundGradient };` : '' }`;

	// Hover
	let innerHoverStyleVars = `${ has( blockAdvanceOptions, 'innerBlock.hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverTextColor ) ? `color: ${ blockAdvanceOptions.innerBlock.hoverTextColor };` : '' }`;
	innerHoverStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBackgroundColor ) ? `background: ${ blockAdvanceOptions.innerBlock.hoverBackgroundColor };` : '' }`;
	innerHoverStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBackgroundGradient ) ? `background: ${ blockAdvanceOptions.innerBlock.hoverBackgroundGradient };` : '' }`;
	innerHoverStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.innerBlock.hoverBorderColor };` : '' }`;

	if ( innerStyleVars ) {
		css += `${ innerBlockSelector } { ${ innerStyleVars } }`;
	}
	if ( innerHoverStyleVars ) {
		css += `${ innerBlockSelector }:hover { ${ innerHoverStyleVars } }`;
	}

	innerHoverStyleVars = '';
	innerHoverStyleVars += `${ blockAdvanceOptions?.innerBlock?.thumbnailMinHeight ? `min-height:${ blockAdvanceOptions?.innerBlock?.thumbnailMinHeight }` : '' }`;
	if ( innerHoverStyleVars ) {
		const innerBlockImgSelector = `.gutenify-section-${ blockClientId }.wp-block-gutenify-post-carousel .gutenify-post-carousel-thumb img`;
		css += `${ innerBlockImgSelector } { ${ innerHoverStyleVars } }`;
	}

	// Box Shadow
	const innerBlockBoxShadow = blockAdvanceOptions?.innerBlock?.boxShadow ? blockAdvanceOptions.innerBlock.boxShadow : {};
	const isBoxShadowActive = innerBlockBoxShadow?.color || innerBlockBoxShadow?.horizontal || innerBlockBoxShadow?.vertical || innerBlockBoxShadow?.blur || innerBlockBoxShadow?.spread || innerBlockBoxShadow?.position;

	innerHoverStyleVars = '';
	if ( isBoxShadowActive ) {
		const bsColor = innerBlockBoxShadow?.color ? innerBlockBoxShadow?.color : '#7a7a7a1a';
		const bsHorizontal = innerBlockBoxShadow?.horizontal ? innerBlockBoxShadow?.horizontal : 0;
		const bsVertical = innerBlockBoxShadow?.vertical ? innerBlockBoxShadow?.vertical : 0;
		const bsBlur = innerBlockBoxShadow?.blur ? innerBlockBoxShadow?.blur : 32;
		const bsSpread = innerBlockBoxShadow?.spread ? innerBlockBoxShadow?.spread : 0;
		const bsPosition = innerBlockBoxShadow?.position && 'inset' === innerBlockBoxShadow.position ? 'inset' : '';
		innerHoverStyleVars = `box-shadow: ${ bsHorizontal }px ${ bsVertical }px ${ bsBlur }px ${ bsSpread }px ${ bsColor } ${ bsPosition };`;
	}
	if ( innerHoverStyleVars ) {
		const innerBlockImgSelector = `${ selector } .gutenify-post-carousel-item-inner-wrapper`;
		css += `${ innerBlockImgSelector } { ${ innerHoverStyleVars } }`;
	}

	// Padding
	const paddings = blockAdvanceOptions?.innerBlock?.contentPadding ? blockAdvanceOptions.innerBlock.contentPadding : {};
	const innerBlockImgSelector = `${ selector } .gutenify-post-carousel-text-content`;
	innerHoverStyleVars = getSpacingCss( paddings, innerBlockImgSelector );
	if ( innerHoverStyleVars ) {
		css += innerHoverStyleVars;
	}
	// Post title font size
	if ( blockAdvanceOptions?.innerBlock?.postTitleSize ) {
		selector = `${ selector } .gutenify-post-carousel-title`;
		innerHoverStyleVars = `font-size: ${ blockAdvanceOptions.innerBlock.postTitleSize };`;
		css += `${ selector } { ${ innerHoverStyleVars } }`;
	}

	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}
export default styling;

